import { ChartType } from '@dbl/core/chart';

import type {
  IAnalysisBarChartResponseDto,
  IAnalysisBarChartResultVo,
} from '../types';

import { pickAxisChartWireVo, pickChartDisplayMeta } from './common';

export function transformBarChartResponseDtoToVo(
  dto: IAnalysisBarChartResponseDto,
): IAnalysisBarChartResultVo {
  const { bar_charts: barChartWire } = dto;
  const { chartData: barChart, isNoData } = pickAxisChartWireVo(barChartWire);

  return {
    ...pickChartDisplayMeta(dto),
    chartType: ChartType.Bar,
    isNoData,
    /** `isNoData === true` 时 omit `barChart`，见 `transformers/common.ts` · payload omit 约定。 */
    ...(isNoData ? {} : { barChart }),
  };
}
